import { useParams } from 'react-router-dom';

import { RouteConfigProvider } from '@/context/route-config';
import useUserPid from '@/features/auth/hooks/use-user-pid';
import FcaQuestionnaireForm, { type FcaQuestionnaireRouteConfig } from '@/features/onboarding/fca-questionnaire/components/form';
import BaseLayout from '@/layouts/base';
import ErrorPage from '@/pages/error';
import LoadingPage from '@/pages/loading';

const ROUTE_CONFIG = {
  ineligible: '/onboarding/fca-questionnaire/ineligible',
  next: '/onboarding/verification',
  personalInformation: '/onboarding/personal-information',
} satisfies FcaQuestionnaireRouteConfig;

const FcaQuestionnaireRetakePage = () => {
  const { isLoading: isLoadingPid, pid } = useUserPid();
  const { pid: paramsPid } = useParams();

  if (isLoadingPid) return <LoadingPage />;

  if (!paramsPid || paramsPid !== pid) return <ErrorPage />;

  return (
    <BaseLayout>
      <RouteConfigProvider config={ROUTE_CONFIG}>
        <FcaQuestionnaireForm />
      </RouteConfigProvider>
    </BaseLayout>
  );
};
FcaQuestionnaireRetakePage.displayName = 'FcaQuestionnaireRetakePage';

export default FcaQuestionnaireRetakePage;
